(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eh-more-payment-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eh-more-payment-options')) {
    customElements.define('eh-more-payment-options', class extends HTMLElement {
      connectedCallback() {
        this.template = this.querySelector('.eh-mpo__template');
        this.scope = this.closest('.product-form__buttons') || this.parentElement;
        if (!this.template || !this.scope) return;

        this.decorate();
        this.observer?.disconnect();
        this.observer = new MutationObserver(() => this.decorate());
        this.observer.observe(this.scope, { childList: true, subtree: true });
      }

      decorate() {
        const buttons = this.scope.querySelectorAll('.shopify-payment-button__more-options');
        buttons.forEach((button) => {
          if (button.dataset.ehMpo === 'true') return;
          button.dataset.ehMpo = 'true';
          button.classList.add('eh-mpo');
          const label = this.dataset.label;
          if (label) button.setAttribute('aria-label', label);
          button.replaceChildren(this.template.content.cloneNode(true));
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eh-payment-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eh-payment-options')) {
    customElements.define('eh-payment-options', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const trigger = this.querySelector('.eh-payment-options__summary');
        const dialog = this.querySelector('dialog');
        const closeButton = this.querySelector('.eh-payment-options__close');
        if (!trigger || !dialog || !closeButton) return;

        trigger.addEventListener('click', () => {
          if (dialog.open) return;
          dialog.showModal();
          trigger.setAttribute('aria-expanded', 'true');
        }, options);

        closeButton.addEventListener('click', () => dialog.close(), options);

        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
            dialog.close();
          }
        }, options);

        dialog.addEventListener('close', () => {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus({ preventScroll: true });
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
        const dialog = this.querySelector('dialog');
        if (dialog?.open) dialog.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eh-sticky-mobile-atc.backup-20260916"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eh-mobile-atc')) {
  customElements.define('eh-mobile-atc', class extends HTMLElement {
    connectedCallback() {
      this.action = this.querySelector('.eh-sticky-atc__button');
      this.label = this.action.querySelector('span');
      this.price = this.querySelector('.eh-sticky-atc__price');
      this.titleNode = this.querySelector('.eh-sticky-atc__title');
      this.quantity = this.querySelector('[data-eh-quantity]');
      this.minus = this.querySelector('[data-eh-minus]');
      this.plus = this.querySelector('[data-eh-plus]');
      this.variants = JSON.parse(this.querySelector('[data-eh-variants]').textContent);
      this.sectionRoot = document.getElementById('shopify-section-' + this.dataset.section);
      this.abort = new AbortController();
      this.primaryQuantity = () => document.getElementById('Quantity-' + this.dataset.section);
      this.commitQuantity = () => {
        const source = this.primaryQuantity();
        if (!source) return;
        const min = Number(source.min) || 1;
        const step = Number(source.step) || 1;
        const max = source.max ? Number(source.max) : Infinity;
        const raw = Number(this.quantity.value) || min;
        const snapped = min + Math.max(0, Math.round((raw - min) / step)) * step;
        source.value = String(Math.max(min, Math.min(snapped, max)));
        this.quantity.value = source.value;
        source.dispatchEvent(new Event('change', {bubbles:true}));
        this.update();
      };
      this.update = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const primary = document.getElementById('ProductSubmitButton-' + this.dataset.section);
          if (!primary) return;
          const heading = this.sectionRoot?.querySelector('h1');
          if (heading && this.titleNode.textContent !== heading.textContent.trim()) this.titleNode.textContent = heading.textContent.trim();
          const busy = primary.getAttribute('aria-disabled') === 'true';
          this.action.disabled = primary.disabled || busy;
          this.action.setAttribute('aria-busy', String(busy));
          const sourceLabel = primary.querySelector('span')?.textContent.trim();
          const label = primary.disabled ? sourceLabel : this.dataset.addLabel;
          if (label && this.label.textContent !== label) this.label.textContent = label;
          const form = document.getElementById('product-form-' + this.dataset.section);
          const variantId = form?.querySelector('input[name="id"]')?.value;
          const variant = this.variants[variantId];
          const visiblePrice = this.sectionRoot?.querySelector('.eh-cz-top__price');
          const price = variant?.price || visiblePrice?.textContent.trim();
          if (price && this.price.textContent !== price) this.price.textContent = price;
          this.querySelector('.eh-sticky-atc__stock').hidden = !variant?.inStock || primary.disabled;
          const source = this.primaryQuantity();
          this.querySelector('.eh-sticky-atc__quantity').hidden = !source;
          if (source) {
            this.quantity.min = source.min || '1';
            this.quantity.step = source.step || '1';
            if (source.max) this.quantity.max = source.max; else this.quantity.removeAttribute('max');
            if (document.activeElement !== this.quantity) this.quantity.value = source.value;
            this.quantity.disabled = primary.disabled || busy;
            this.minus.disabled = this.quantity.disabled || Number(source.value) <= Number(this.quantity.min);
            this.plus.disabled = this.quantity.disabled || Boolean(source.max && Number(source.value) >= Number(source.max));
          }
          const overlay = document.querySelector('dialog[open], cart-drawer.active, .drawer.active, menu-drawer details[open], details-modal details[open], product-modal[open]');
          const visible = matchMedia('(max-width:749px)').matches && primary.getBoundingClientRect().bottom < 0 && !overlay;
          this.classList.toggle('is-visible', visible);
          this.setAttribute('aria-hidden', String(!visible));
          this.inert = !visible;
        });
      };
      const signal = this.abort.signal;
      this.minus.addEventListener('click', () => { this.quantity.stepDown(); this.commitQuantity(); }, {signal});
      this.plus.addEventListener('click', () => { this.quantity.stepUp(); this.commitQuantity(); }, {signal});
      this.quantity.addEventListener('change', this.commitQuantity, {signal});
      this.quantity.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); this.commitQuantity(); this.action.focus(); }
      }, {signal});
      document.addEventListener('change', this.update, {signal});
      document.addEventListener('input', event => { if (event.target === this.primaryQuantity()) this.update(); }, {signal});
      window.addEventListener('scroll', this.update, {signal,passive:true});
      window.addEventListener('resize', this.update, {signal,passive:true});
      this.action.addEventListener('click', () => {
        this.commitQuantity();
        const primary = document.getElementById('ProductSubmitButton-' + this.dataset.section);
        if (primary && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true') primary.click();
        this.update();
      }, {signal});
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.update();
      });
      this.observer.observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','open','disabled','aria-disabled','min','max','step','value']});
      this.querySelector('img')?.addEventListener('error', event => event.target.remove(), {signal});
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eh-sticky-mobile-atc.backup-20260916b"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eh-mobile-atc')) {
  customElements.define('eh-mobile-atc', class extends HTMLElement {
    connectedCallback() {
      this.action = this.querySelector('.eh-sticky-atc__button');
      this.label = this.action.querySelector('span');
      this.price = this.querySelector('.eh-sticky-atc__price');
      this.titleNode = this.querySelector('.eh-sticky-atc__title');
      this.stockNode = this.querySelector('.eh-sticky-atc__stock');
      this.quantity = this.querySelector('[data-eh-quantity]');
      this.minus = this.querySelector('[data-eh-minus]');
      this.plus = this.querySelector('[data-eh-plus]');
      this.variants = JSON.parse(this.querySelector('[data-eh-variants]').textContent);
      this.defaultInStock = this.dataset.defaultInStock === 'true';
      this.sectionRoot = document.getElementById('shopify-section-' + this.dataset.section);
      this.abort = new AbortController();
      this.primaryQuantity = () => document.getElementById('Quantity-' + this.dataset.section);
      this.commitQuantity = () => {
        const source = this.primaryQuantity();
        if (!source) return;
        const min = Number(source.min) || 1;
        const step = Number(source.step) || 1;
        const max = source.max ? Number(source.max) : Infinity;
        const raw = Number(this.quantity.value) || min;
        const snapped = min + Math.max(0, Math.round((raw - min) / step)) * step;
        source.value = String(Math.max(min, Math.min(snapped, max)));
        this.quantity.value = source.value;
        source.dispatchEvent(new Event('change', {bubbles:true}));
        this.update();
      };
      this.update = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const primary = document.getElementById('ProductSubmitButton-' + this.dataset.section);
          if (!primary) return;
          const heading = this.sectionRoot?.querySelector('h1');
          if (heading && this.titleNode.textContent !== heading.textContent.trim()) this.titleNode.textContent = heading.textContent.trim();
          const busy = primary.getAttribute('aria-disabled') === 'true';
          this.action.disabled = primary.disabled || busy;
          this.action.setAttribute('aria-busy', String(busy));
          const sourceLabel = primary.querySelector('span')?.textContent.trim();
          const label = primary.disabled ? sourceLabel : this.dataset.addLabel;
          if (label && this.label.textContent !== label) this.label.textContent = label;
          const form = document.getElementById('product-form-' + this.dataset.section);
          const variantId = form?.querySelector('input[name="id"]')?.value;
          const variant = this.variants[variantId];
          const visiblePrice = this.sectionRoot?.querySelector('.eh-cz-top__price');
          const price = variant?.price || visiblePrice?.textContent.trim();
          if (price && this.price.textContent !== price) this.price.textContent = price;
          const inStock = variant ? variant.inStock : this.defaultInStock;
          this.stockNode.hidden = !inStock || primary.disabled;
          const source = this.primaryQuantity();
          this.querySelector('.eh-sticky-atc__quantity').hidden = !source;
          if (source) {
            this.quantity.min = source.min || '1';
            this.quantity.step = source.step || '1';
            if (source.max) this.quantity.max = source.max; else this.quantity.removeAttribute('max');
            if (document.activeElement !== this.quantity) this.quantity.value = source.value;
            this.quantity.disabled = primary.disabled || busy;
            this.minus.disabled = this.quantity.disabled || Number(source.value) <= Number(this.quantity.min);
            this.plus.disabled = this.quantity.disabled || Boolean(source.max && Number(source.value) >= Number(source.max));
          }
          const overlay = document.querySelector('dialog[open], cart-drawer.active, .drawer.active, menu-drawer details[open], details-modal details[open], product-modal[open]');
          const visible = matchMedia('(max-width:749px)').matches && primary.getBoundingClientRect().bottom < 0 && !overlay;
          this.classList.toggle('is-visible', visible);
          this.setAttribute('aria-hidden', String(!visible));
          this.inert = !visible;
        });
      };
      const signal = this.abort.signal;
      this.minus.addEventListener('click', () => { this.quantity.stepDown(); this.commitQuantity(); }, {signal});
      this.plus.addEventListener('click', () => { this.quantity.stepUp(); this.commitQuantity(); }, {signal});
      this.quantity.addEventListener('change', this.commitQuantity, {signal});
      this.quantity.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); this.commitQuantity(); this.action.focus(); }
      }, {signal});
      document.addEventListener('change', this.update, {signal});
      document.addEventListener('input', event => { if (event.target === this.primaryQuantity()) this.update(); }, {signal});
      window.addEventListener('scroll', this.update, {signal,passive:true});
      window.addEventListener('resize', this.update, {signal,passive:true});
      this.action.addEventListener('click', () => {
        this.commitQuantity();
        const primary = document.getElementById('ProductSubmitButton-' + this.dataset.section);
        if (primary && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true') primary.click();
        this.update();
      }, {signal});
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.update();
      });
      this.observer.observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','open','disabled','aria-disabled','min','max','step','value']});
      this.querySelector('img')?.addEventListener('error', event => event.target.remove(), {signal});
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eh-sticky-mobile-atc.backup-20260916c-mobileonly"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eh-mobile-atc')) {
  customElements.define('eh-mobile-atc', class extends HTMLElement {
    static moneyParts(text) {
      if (!text) return null;
      const match = String(text).match(/\d[\d.,\s ']*\d|\d/);
      if (!match) return null;
      const flat = match[0].replace(/[\s ']/g, '');
      const dec = flat.match(/([.,])(\d{1,2})$/);
      return {raw: match[0], flat: flat, sep: dec ? dec[1] : null, digits: dec ? dec[2].length : 0, decimals: dec ? dec[2] : ''};
    }
    static parseCents(text) {
      const parts = this.moneyParts(text);
      if (!parts) return null;
      let value;
      if (parts.sep) {
        const whole = parts.flat.slice(0, parts.flat.length - parts.digits - 1).replace(/[.,]/g, '');
        value = Number((whole || '0') + '.' + parts.decimals);
      } else {
        value = Number(parts.flat.replace(/[.,]/g, ''));
      }
      return Number.isFinite(value) ? Math.round(value * 100) : null;
    }
    static formatMoney(cents, template) {
      const parts = this.moneyParts(template);
      if (!parts) return template;
      const groupSep = parts.sep === ',' ? '.' : ',';
      const fixed = (cents / 100).toFixed(parts.digits);
      const chunks = fixed.split('.');
      const intPart = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
      const out = chunks[1] ? intPart + parts.sep + chunks[1] : intPart;
      return String(template).replace(parts.raw, out);
    }
    connectedCallback() {
      this.action = this.querySelector('.eh-sticky-atc__button');
      this.label = this.action.querySelector('span');
      this.price = this.querySelector('.eh-sticky-atc__price');
      this.titleNode = this.querySelector('.eh-sticky-atc__title');
      this.stockNode = this.querySelector('.eh-sticky-atc__stock');
      this.quantity = this.querySelector('[data-eh-quantity]');
      this.minus = this.querySelector('[data-eh-minus]');
      this.plus = this.querySelector('[data-eh-plus]');
      this.variants = JSON.parse(this.querySelector('[data-eh-variants]').textContent);
      this.defaultInStock = this.dataset.defaultInStock === 'true';
      this.sectionRoot = document.getElementById('shopify-section-' + this.dataset.section);
      this.unitNode = document.createElement('p');
      this.unitNode.className = 'eh-sticky-atc__unit';
      this.price.insertAdjacentElement('afterend', this.unitNode);
      this.abort = new AbortController();
      this.primaryQuantity = () => document.getElementById('Quantity-' + this.dataset.section);
      this.commitQuantity = () => {
        const source = this.primaryQuantity();
        if (!source) return;
        const min = Number(source.min) || 1;
        const step = Number(source.step) || 1;
        const max = source.max ? Number(source.max) : Infinity;
        const raw = Number(this.quantity.value) || min;
        const snapped = min + Math.max(0, Math.round((raw - min) / step)) * step;
        source.value = String(Math.max(min, Math.min(snapped, max)));
        this.quantity.value = source.value;
        source.dispatchEvent(new Event('change', {bubbles:true}));
        this.update();
      };
      this.update = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const primary = document.getElementById('ProductSubmitButton-' + this.dataset.section);
          if (!primary) return;
          const heading = this.sectionRoot?.querySelector('h1');
          if (heading && this.titleNode.textContent !== heading.textContent.trim()) this.titleNode.textContent = heading.textContent.trim();
          const busy = primary.getAttribute('aria-disabled') === 'true';
          this.action.disabled = primary.disabled || busy;
          this.action.setAttribute('aria-busy', String(busy));
          const sourceLabel = primary.querySelector('span')?.textContent.trim();
          const label = primary.disabled ? sourceLabel : this.dataset.addLabel;
          if (label && this.label.textContent !== label) this.label.textContent = label;
          const form = document.getElementById('product-form-' + this.dataset.section);
          const variantId = form?.querySelector('input[name="id"]')?.value;
          const variant = this.variants[variantId];
          const inStock = variant ? variant.inStock : this.defaultInStock;
          this.stockNode.hidden = !inStock || primary.disabled;
          const source = this.primaryQuantity();
          this.querySelector('.eh-sticky-atc__quantity').hidden = !source;
          if (source) {
            this.quantity.min = source.min || '1';
            this.quantity.step = source.step || '1';
            if (source.max) this.quantity.max = source.max; else this.quantity.removeAttribute('max');
            if (document.activeElement !== this.quantity) this.quantity.value = source.value;
            this.quantity.disabled = primary.disabled || busy;
            this.minus.disabled = this.quantity.disabled || Number(source.value) <= Number(this.quantity.min);
            this.plus.disabled = this.quantity.disabled || Boolean(source.max && Number(source.value) >= Number(source.max));
          }
          const visiblePrice = this.sectionRoot?.querySelector('.eh-cz-top__price');
          const template = variant?.price || visiblePrice?.textContent.trim();
          const ctor = this.constructor;
          const unitCents = typeof variant?.cents === 'number' ? variant.cents : ctor.parseCents(template);
          const hasCents = typeof unitCents === 'number' && Number.isFinite(unitCents);
          const qty = Math.max(1, Math.floor(Number(source ? source.value : this.quantity.value)) || 1);
          const total = template && hasCents ? ctor.formatMoney(unitCents * qty, template) : template;
          if (total && this.price.textContent !== total) this.price.textContent = total;
          const unitText = qty > 1 && template && hasCents ? qty + ' × ' + ctor.formatMoney(unitCents, template) : '';
          if (this.unitNode.textContent !== unitText) this.unitNode.textContent = unitText;
          this.unitNode.classList.toggle('is-shown', Boolean(unitText));
          const overlay = document.querySelector('dialog[open], cart-drawer.active, .drawer.active, menu-drawer details[open], details-modal details[open], product-modal[open]');
          const visible = matchMedia('(max-width:749px)').matches && primary.getBoundingClientRect().bottom < 0 && !overlay;
          this.classList.toggle('is-visible', visible);
          this.setAttribute('aria-hidden', String(!visible));
          this.inert = !visible;
        });
      };
      const signal = this.abort.signal;
      this.minus.addEventListener('click', () => { this.quantity.stepDown(); this.commitQuantity(); }, {signal});
      this.plus.addEventListener('click', () => { this.quantity.stepUp(); this.commitQuantity(); }, {signal});
      this.quantity.addEventListener('change', this.commitQuantity, {signal});
      this.quantity.addEventListener('input', this.update, {signal});
      this.quantity.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); this.commitQuantity(); this.action.focus(); }
      }, {signal});
      document.addEventListener('change', this.update, {signal});
      document.addEventListener('input', event => { if (event.target === this.primaryQuantity()) this.update(); }, {signal});
      window.addEventListener('scroll', this.update, {signal,passive:true});
      window.addEventListener('resize', this.update, {signal,passive:true});
      this.action.addEventListener('click', () => {
        this.commitQuantity();
        const primary = document.getElementById('ProductSubmitButton-' + this.dataset.section);
        if (primary && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true') primary.click();
        this.update();
      }, {signal});
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.update();
      });
      this.observer.observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','open','disabled','aria-disabled','min','max','step','value']});
      this.querySelector('img')?.addEventListener('error', event => event.target.remove(), {signal});
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eh-sticky-mobile-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eh-mobile-atc')) {
  customElements.define('eh-mobile-atc', class extends HTMLElement {
    static moneyParts(text) {
      if (!text) return null;
      const match = String(text).match(/\d[\d.,\s ']*\d|\d/);
      if (!match) return null;
      const flat = match[0].replace(/[\s ']/g, '');
      const dec = flat.match(/([.,])(\d{1,2})$/);
      return {raw: match[0], flat: flat, sep: dec ? dec[1] : null, digits: dec ? dec[2].length : 0, decimals: dec ? dec[2] : ''};
    }
    static parseCents(text) {
      const parts = this.moneyParts(text);
      if (!parts) return null;
      let value;
      if (parts.sep) {
        const whole = parts.flat.slice(0, parts.flat.length - parts.digits - 1).replace(/[.,]/g, '');
        value = Number((whole || '0') + '.' + parts.decimals);
      } else {
        value = Number(parts.flat.replace(/[.,]/g, ''));
      }
      return Number.isFinite(value) ? Math.round(value * 100) : null;
    }
    static formatMoney(cents, template) {
      const parts = this.moneyParts(template);
      if (!parts) return template;
      const groupSep = parts.sep === ',' ? '.' : ',';
      const fixed = (cents / 100).toFixed(parts.digits);
      const chunks = fixed.split('.');
      const intPart = chunks[0].replace(/\B(?=(\d{3})+(?!\d))/g, groupSep);
      const out = chunks[1] ? intPart + parts.sep + chunks[1] : intPart;
      return String(template).replace(parts.raw, out);
    }
    connectedCallback() {
      this.action = this.querySelector('.eh-sticky-atc__button');
      this.label = this.action.querySelector('span');
      this.price = this.querySelector('.eh-sticky-atc__price');
      this.titleNode = this.querySelector('.eh-sticky-atc__title');
      this.stockNode = this.querySelector('.eh-sticky-atc__stock');
      this.quantity = this.querySelector('[data-eh-quantity]');
      this.minus = this.querySelector('[data-eh-minus]');
      this.plus = this.querySelector('[data-eh-plus]');
      this.variants = JSON.parse(this.querySelector('[data-eh-variants]').textContent);
      this.defaultInStock = this.dataset.defaultInStock === 'true';
      this.sectionRoot = document.getElementById('shopify-section-' + this.dataset.section);
      this.unitNode = document.createElement('p');
      this.unitNode.className = 'eh-sticky-atc__unit';
      this.price.insertAdjacentElement('afterend', this.unitNode);
      this.abort = new AbortController();
      this.primaryQuantity = () => document.getElementById('Quantity-' + this.dataset.section);
      this.commitQuantity = () => {
        const source = this.primaryQuantity();
        if (!source) return;
        const min = Number(source.min) || 1;
        const step = Number(source.step) || 1;
        const max = source.max ? Number(source.max) : Infinity;
        const raw = Number(this.quantity.value) || min;
        const snapped = min + Math.max(0, Math.round((raw - min) / step)) * step;
        source.value = String(Math.max(min, Math.min(snapped, max)));
        this.quantity.value = source.value;
        source.dispatchEvent(new Event('change', {bubbles:true}));
        this.update();
      };
      this.update = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const primary = document.getElementById('ProductSubmitButton-' + this.dataset.section);
          if (!primary) return;
          const heading = this.sectionRoot?.querySelector('h1');
          if (heading && this.titleNode.textContent !== heading.textContent.trim()) this.titleNode.textContent = heading.textContent.trim();
          const busy = primary.getAttribute('aria-disabled') === 'true';
          this.action.disabled = primary.disabled || busy;
          this.action.setAttribute('aria-busy', String(busy));
          const sourceLabel = primary.querySelector('span')?.textContent.trim();
          const label = primary.disabled ? sourceLabel : this.dataset.addLabel;
          if (label && this.label.textContent !== label) this.label.textContent = label;
          const form = document.getElementById('product-form-' + this.dataset.section);
          const variantId = form?.querySelector('input[name="id"]')?.value;
          const variant = this.variants[variantId];
          const inStock = variant ? variant.inStock : this.defaultInStock;
          this.stockNode.hidden = !inStock || primary.disabled;
          const source = this.primaryQuantity();
          this.querySelector('.eh-sticky-atc__quantity').hidden = !source;
          if (source) {
            this.quantity.min = source.min || '1';
            this.quantity.step = source.step || '1';
            if (source.max) this.quantity.max = source.max; else this.quantity.removeAttribute('max');
            if (document.activeElement !== this.quantity) this.quantity.value = source.value;
            this.quantity.disabled = primary.disabled || busy;
            this.minus.disabled = this.quantity.disabled || Number(source.value) <= Number(this.quantity.min);
            this.plus.disabled = this.quantity.disabled || Boolean(source.max && Number(source.value) >= Number(source.max));
          }
          const visiblePrice = this.sectionRoot?.querySelector('.eh-cz-top__price');
          const template = variant?.price || visiblePrice?.textContent.trim();
          const ctor = this.constructor;
          const unitCents = typeof variant?.cents === 'number' ? variant.cents : ctor.parseCents(template);
          const hasCents = typeof unitCents === 'number' && Number.isFinite(unitCents);
          const qty = Math.max(1, Math.floor(Number(source ? source.value : this.quantity.value)) || 1);
          const total = template && hasCents ? ctor.formatMoney(unitCents * qty, template) : template;
          if (total && this.price.textContent !== total) this.price.textContent = total;
          const unitText = qty > 1 && template && hasCents ? qty + ' × ' + ctor.formatMoney(unitCents, template) : '';
          if (this.unitNode.textContent !== unitText) this.unitNode.textContent = unitText;
          this.unitNode.classList.toggle('is-shown', Boolean(unitText));
          const overlay = document.querySelector('dialog[open], cart-drawer.active, .drawer.active, menu-drawer details[open], details-modal details[open], product-modal[open]');
          const visible = primary.getBoundingClientRect().bottom < 0 && !overlay;
          this.classList.toggle('is-visible', visible);
          this.setAttribute('aria-hidden', String(!visible));
          this.inert = !visible;
        });
      };
      const signal = this.abort.signal;
      this.minus.addEventListener('click', () => { this.quantity.stepDown(); this.commitQuantity(); }, {signal});
      this.plus.addEventListener('click', () => { this.quantity.stepUp(); this.commitQuantity(); }, {signal});
      this.quantity.addEventListener('change', this.commitQuantity, {signal});
      this.quantity.addEventListener('input', this.update, {signal});
      this.quantity.addEventListener('keydown', event => {
        if (event.key === 'Enter') { event.preventDefault(); this.commitQuantity(); this.action.focus(); }
      }, {signal});
      document.addEventListener('change', this.update, {signal});
      document.addEventListener('input', event => { if (event.target === this.primaryQuantity()) this.update(); }, {signal});
      window.addEventListener('scroll', this.update, {signal,passive:true});
      window.addEventListener('resize', this.update, {signal,passive:true});
      this.action.addEventListener('click', () => {
        this.commitQuantity();
        const primary = document.getElementById('ProductSubmitButton-' + this.dataset.section);
        if (primary && !primary.disabled && primary.getAttribute('aria-disabled') !== 'true') primary.click();
        this.update();
      }, {signal});
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.update();
      });
      this.observer.observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['class','open','disabled','aria-disabled','min','max','step','value']});
      this.querySelector('img')?.addEventListener('error', event => event.target.remove(), {signal});
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    const initMegaMenuHover = () => {
    const hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

    document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      const details = menu.querySelector(':scope > details.mega-menu');
      if (!details || menu.dataset.hoverReady === 'true') return;

      const summary = details.querySelector(':scope > summary');
      let closeTimer;

      menu.dataset.hoverReady = 'true';

      menu.addEventListener('mouseenter', () => {
        if (!hoverMedia.matches) return;

        window.clearTimeout(closeTimer);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      menu.addEventListener('mouseleave', () => {
        if (!hoverMedia.matches) return;

        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (menu.contains(document.activeElement)) return;

          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, 140);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuHover, { once: true });
  } else {
    initMegaMenuHover();
  }

  const announcementBar = document.querySelector('.announcement-bar-section');

  const syncAnnouncementBar = () => {
    if (!announcementBar) return;
    announcementBar.classList.toggle('euhealth-announcement-collapsed', window.scrollY > 12);
  };

  window.addEventListener('scroll', syncAnnouncementBar, { passive: true });
  syncAnnouncementBar();
  } catch(e) { console.error(e); }
})();

})();
